<template>
  <div>
    <div >
      <IndirectPepsForm
        v-on:displayAllInderectPeps="onIndirectPepFormClick"
        v-if="!showAllIndirectPeps"
        />
      <IndirectPepsTable
        class="dependent-table--mb"
        v-on:displayAllInderectPeps="onIndirectPepFormClick"
        v-else
        />
    </div>
    <div class="btn-container" v-if="showAllIndirectPeps">
        <button
          class="button"
          @click.prevent="submit()">
          GUARDAR
        </button>
      </div>
  </div>
</template>

<script>

import userProfileMixin from '@/mixins/userProfileMixin'
import mixins from '@/mixins/index'
import httpRequestMixin from '@/mixins/httpRequestMixin'

import IndirectPepsTable from '@/components/IndirectPeps/IndirectPepsTable'
import IndirectPepsForm from '@/components/IndirectPeps/IndirectPepsForm'

export default {
  name: 'StepIndirectPep',
  components: {
    IndirectPepsTable,
    IndirectPepsForm
  },
  mixins: [mixins, userProfileMixin, httpRequestMixin],
  data () {
    return {
      showAllIndirectPeps: false,
      indirectPepID: '',
      formSubmitted: false
    }
  },
  methods: {
    onIndirectPepFormClick: function (value) {
      this.showAllIndirectPeps = value
    },
    sendDataToServer: async function () {
      await this.$store.dispatch('refreshToken')
      let options = {
        method: 'POST',
        url: process.env.AUTH_BASE + '/profile/peps/indirect/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        },
        data: {
          peps: this.$store.getters['pep/getIndirectPeps']
        }
      }
      const response = await this.httpRequest(options)
      if (response.status === 201) { this.nextStep() }
    },
    submit: function () {
      this.sendDataToServer()
    }
  }
}

</script>

<style lang="scss" scoped>

  .checkbox--label,
  .radio--label {
    display: inline-block;
  }

  .radio--ml {
    margin-left: 1em;
  }

  .dependent-table--mb {
    margin-bottom: 3em;
  }

  .btn-container {
    display: flex;
    justify-content: end;
  }
</style>



// WEBPACK FOOTER //
// src/views/userProfile/profileSteps/StepIndirectPep.vue